
      import Lenis from '@studio-freight/lenis';

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!prefersReducedMotion) {
        const lenis = new Lenis({
          duration: 1.2,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          smoothWheel: true,
          wheelMultiplier: 1.5,
          smoothTouch: false,
          touchMultiplier: 2,
          gestureOrientation: 'vertical',
          orientation: 'vertical',
          infinite: false,
        });

        function raf(time) {
          lenis.raf(time);
          requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);
        window.lenis = lenis;
      }
    